import appConfig from '@/config';
import jwt from 'jsonwebtoken';
import LogRocket from 'logrocket';

import api from '@/services/api';
import router from '@/services/router';
import store from '@/services/store';
import storage from '@/services/storage';

import config from './config';

const { BASE_URL } = appConfig;

const {
  AUTH_TOKEN,
  LOGIN_REDIRECT_URL,
} = config.storageKeys;

export function userHasAccess(role) {
  return store.auth.currentUser?.acl === role;
}

export function signIn(authToken, remainInPage = false) {
  if (!authToken) {
    throw new Error('authToken is required!');
  }

  store.dispatch('auth/signIn', { authToken });

  storage.setItem(AUTH_TOKEN, authToken);
  api.grantAuthorization(authToken);

  if (process.env.NODE_ENV === 'production') {
    const user = jwt.decode(authToken);

    LogRocket.identify(user._id, user);
  }

  const loginRedirectUrl = storage.getItem(LOGIN_REDIRECT_URL) ?? '/';
  storage.removeItem(LOGIN_REDIRECT_URL);

  if (!remainInPage) {
    router.push(loginRedirectUrl);
  }
}

export function signOut(loginRedirectUrl) {
  store.dispatch('auth/signOut');

  storage.removeItem(AUTH_TOKEN);
  api.revokeAuthorization();

  if (loginRedirectUrl) {
    storage.setItem(LOGIN_REDIRECT_URL, loginRedirectUrl);
  }

  window.location.assign(`${BASE_URL}login`);
}

export function loadUserState() {
  const authToken = storage.getItem(AUTH_TOKEN);

  if (authToken) {
    signIn(authToken, true);
  }
}
